import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ws-start-next/ws-start-next/components/PageLayout/PageBaseV2.tsx");
